import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-0" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "f-w-600" }
const _hoisted_8 = { class: "f-w-600" }
const _hoisted_9 = { key: 1 }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { getUserName } from "@/services/utils/Names";
import { useHistoryStore } from "@/store/history/history";

import {
  convertDateFromUTC,
  formatDateStringFromYYYYMMDD,
} from "@/services/utils/DateParser";

interface HistoryLog {
  field: string;
  new: any;
  old: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersHistoryDialog',
  props: {
    entity: {},
    object_id: {},
    visible: { type: Boolean }
  },
  setup(__props: any) {

const store = useHistoryStore();

const filteredHistory = ref([]);
const isLoading = ref(false);

const props = __props;

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

watch(
  () => props.visible,
  (newValue) => {
    filteredHistory.value = [];
    if (newValue && props.object_id != 0) {
      isLoading.value = true;
      store
        .getHistory(props.entity, props.object_id)
        .then(() => {
          filteredHistory.value = store.historyList.map((historyEntry) => {
            return {
              ...historyEntry, // Копируем все свойства объекта
              changes: getFilteredChanges(historyEntry.changes), // Заменяем поле `changes`
            };
          });

          filteredHistory.value = filteredHistory.value.filter(
            (e) => e.changes.length > 0 || e.operation_type == "INSERT"
          );
        })
        .finally(() => {
          isLoading.value = false;
        });
    }
  }
);

const getFilteredChanges = (changes: any) => {
  const changesResult = [] as HistoryLog[];
  for (const key in changes) {
    if (!store.excludedFields.includes(key)) {
      const keyName = store.fieldsMap.get(key) || key;
      let newValue = changes[key].new;
      let oldValue = changes[key].old;

      if (oldValue != null) {
        if (store.dateFields.includes(key)) {
          newValue = formatDateStringFromYYYYMMDD(newValue);
          oldValue = formatDateStringFromYYYYMMDD(oldValue);
        }

        if (key == "brand_pk") {
          newValue = newValue["brand_name"] || null;
          oldValue = oldValue["brand_name"] || null;
        } else if (key == "shop_id") {
          newValue = newValue["shop_name"] || null;
          oldValue = oldValue["shop_name"] || null;
        } else if (key == "source_slug" || key == "platform_slug") {
          newValue = newValue["name"] || null;
          oldValue = oldValue["name"] || null;
        } else if (key == "role_id") {
          newValue = `${newValue["name"]} (организация ${newValue["department"]["organization"]["name"]}, департамент ${newValue["department"]["name"]})`;
          oldValue = `${oldValue["name"]} (организация ${oldValue["department"]["organization"]["name"]}, департамент ${oldValue["department"]["name"]})`;
        }

        if (newValue === "" || newValue == null) newValue = "'пустое значение'";
        if (oldValue === "" || oldValue == null) oldValue = "'пустое значение'";

        changesResult.push({
          field: keyName,
          new: newValue,
          old: oldValue,
        });
      }
    }
  }
  return changesResult;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visibleLocal.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visibleLocal).value = $event)),
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    maximizable: "",
    modal: "",
    header: "История изменений",
    style: _normalizeStyle([{ width: '70vw' }, {"max-height":"70vh"}]),
    breakpoints: { '1199px': '75vw', '575px': '90vw' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createVNode(_unref(DataTable), {
          value: filteredHistory.value,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "action",
              header: "Действие"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.operation_type)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(store).operationsMap.get(slotProps.data.operation_type)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "user",
              header: "Пользователь"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.changed_by)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(getUserName)(slotProps.data.changed_by)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "time",
              header: "Дата и время"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.changed_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "changes",
              header: "Что изменилось"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.operation_type == 'UPDATE')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.changes, (ch) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "m-b-4",
                          key: ch.field
                        }, [
                          _createTextVNode(_toDisplayString(ch.field) + ": с ", 1),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(ch.old), 1),
                          _createTextVNode(" на "),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(ch.new), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})